"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _mdxDeck = require("mdx-deck");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var fillArrayWithNumbers = function fillArrayWithNumbers(n) {
  var arr = Array.apply(null, Array(n));
  return arr.map(function (_, i) {
    return i;
  });
};

var Container = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 2em;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n"])));

var PacmanContainer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: 2px;\n"])));

var PacmanUp = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  height: 10px;\n  width: 20px;\n  background-color: #ffcc33;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  transform: rotate(-25deg);\n"])));

var PacmanDown = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  height: 10px;\n  width: 20px;\n  background-color: #ffcc33;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  transform: rotate(25deg);\n"])));

var PacmanClosed = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  height: 20px;\n  width: 20px;\n  background-color: #ffcc33;\n  border-radius: 20px;\n"])));

var PacmanFood = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  height: 5px;\n  width: 5px;\n  margin: 2px;\n  background-color: #d49b7f;\n  border-radius: 1px;\n  display: inline-block;\n"])));

var Pacman = function Pacman() {
  var _useDeck = (0, _mdxDeck.useDeck)(),
      length = _useDeck.length,
      index = _useDeck.index;

  var position = index + 1;
  return /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement(PacmanContainer, null, !!(position % 2) ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(PacmanUp, null), /*#__PURE__*/_react["default"].createElement(PacmanDown, null)) : /*#__PURE__*/_react["default"].createElement(PacmanClosed, null)), fillArrayWithNumbers(length - position).map(function (i) {
    return /*#__PURE__*/_react["default"].createElement(PacmanFood, {
      key: "food-".concat(i)
    });
  }));
};

var _default = Pacman;
exports["default"] = _default;